import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";
import {LogadoService} from "../../providers/logado-service";
import {ENUM, TAddDel, TBlendedTipo, TProdutoAuth, TCertifyFlag} from "../../app/enum";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-meritum',
    templateUrl: 'app-meritum.html'
})

export class AppMeritum {

    ENUM: any = ENUM;
    config: any;
    getcard: Function;

    logado: any;
    textfind: string;

    TCertifyFlag: any = TCertifyFlag;


    @Input('meritum') public meritum: any;
    @Input('viewer') public viewer: 'verso' | 'front' | 'hpage' | 'brand';

    @Output('meritum-click') private _click: EventEmitter<any> = new EventEmitter();
    @Output('meritum-botao') private _botao: EventEmitter<any> = new EventEmitter();
    @Output('meritum-finde') private _finde: EventEmitter<any> = new EventEmitter();

    constructor(public util: Util, public logadoService: LogadoService, public sanitizer: DomSanitizer) {

        this.getcard = getcard;
        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

    }

    ngOnInit() {

        if (!this.meritum) {
            this.util.alertSimply('Meritum Array Undefined!', 'Developer Error');
            return;
        }

    }

    _emitClick(item) {

        this._click.emit(item);

    }

    _emitBotao(item, event) {

        event.stopPropagation();
        this._botao.emit(item);

    }

    _emitFinde() {

        if (!this.util.validaCNPF(this.textfind)) return;

        this._finde.emit(this.textfind);
        this.textfind = '';

    }

    expiredText() {

        let certify = this.getcard(this.meritum).Certify;
        let expired = (certify.CertifyFlag == TCertifyFlag.cfExpirado);

        if (!certify.CertifyStop && expired) return 'Card expirado';
        if (!certify.CertifyStop) return 'Card está válido';
        if (certify.CertifyStop)  return 'Válido até ' + this.util.dataft(certify.CertifyStop, null);

    }

}

//#AKI
export function getcard(meritem, freeSale, cria, index: number = null, webstor) {

    //Meritum - Find
    if (!meritem || !meritem.BlendedArray) return null;

    //Blended - Find
    let blended = meritem.BlendedArray.filter(bl => bl.BlendedTipo == TBlendedTipo.btCertify && bl.ProdutoCards.length)[0];
    if (!blended) return null;

    //Produto - Find
    let produto = blended.ProdutoCards.find(bx => !!bx.Certify);
    if (!produto && freeSale && index == null) {
        index = blended.ProdutoCards.findIndex(bx => (bx.ProdutoAuth == TProdutoAuth.paUser));
        produto = blended.ProdutoCards[index];
    }

    //Produto - Cria
    if (produto && cria) {
        let status = (produto.RenovarCash && webstor ? TCertifyFlag.cfExpirado : TCertifyFlag.cfAprovado);
        let expira = (produto.RenovarCash && webstor ? ''                      : produto.ProdutoStop);
        let logado = this.logadoService.getAuth();
        let usuario = {UsuarioID: logado.Profile.ProfileID, UsuarioShow: logado.Profile.ProfileShow, UsuarioFace: logado.Profile.ProfileFace};
        produto.Certify = {CertifyID: 0, CertifySpot: null, CertifyFlag: status, CertifyStop: expira, CertifyHide: TAddDel.adNao, Usuario: usuario};
    }

    //Produto result
    return produto;

}



// WEBPACK FOOTER //
// ./src/components/app-meritum/app-meritum.ts